import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import {Validator as DXValidator} from 'devextreme-react/validator';


export default class Validator extends Component {
    render() {
        const dataAttributes = {};
        if (this.props.loading_state && this.props.loading_state.is_loading) {
            dataAttributes['data-dash-is-loading'] = true;
        }
        return (
            <DXValidator
                {...R.omit(['loading_state', 'setProps', 'children'], this.props)}
                {...dataAttributes}
            >
                {this.props.children}
            </DXValidator>
        );
    }
}

Validator.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,
    /**
     * A collection of an node's child elements
     */
    children: PropTypes.node,

    /**
     * An object that specifies what and when to validate, and how to apply the validation result
     */
    adapter: PropTypes.object,
    /**
     * Specifies the global attributes to be attached to the UI component's container element
     */
    elementAttr: PropTypes.object,
    /**
     * Specifies the UI component's height
     */
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies the editor name to be used in the validation default messages
     */
    name: PropTypes.string,
    /**
     * A function that is executed before the UI component is disposed of
     */
    onDisposing: PropTypes.func,
    /**
     * A function used in JavaScript frameworks to save the UI component instance
     */
    onInitialized: PropTypes.func,
    /**
     * A function that is executed after a UI component property is changed
     */
    onOptionChanged: PropTypes.func,
    /**
     * A function that is executed after a value is validated
     */
    onValidated: PropTypes.func,
    /**
     * Specifies the validation group the editor will be related to
     */
    validationGroup: PropTypes.string,
    /**
     * An array of validation rules to be checked for the editor with which the dxValidator object is associated
     */
    validationRules: PropTypes.arrayOf(PropTypes.object),
    /**
     * Specifies the UI component's width
     */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),

    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func,
    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
};

Validator.defaultProps = {
    adapter: {},
    elementAttr: {},
    // height: undefined,
    // name: '',
    onDisposing: null,
    onInitialized: null,
    onOptionChanged: null,
    onValidated: null,
    // validationGroup: '',
    validationRules: [],
    // width: undefined
};
